import { render } from "./SkeletonInternetServiceMobile.vue?vue&type=template&id=3154f790&scoped=true"
import script from "./SkeletonInternetServiceMobile.vue?vue&type=script&lang=js"
export * from "./SkeletonInternetServiceMobile.vue?vue&type=script&lang=js"

import "./SkeletonInternetServiceMobile.vue?vue&type=style&index=0&id=3154f790&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3154f790"
/* hot reload */
if (module.hot) {
  script.__hmrId = "3154f790"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3154f790', script)) {
    api.reload('3154f790', script)
  }
  
  module.hot.accept("./SkeletonInternetServiceMobile.vue?vue&type=template&id=3154f790&scoped=true", () => {
    api.rerender('3154f790', render)
  })

}

script.__file = "src/ui/skeleton/services/SkeletonInternetServiceMobile.vue"

export default script